import dynamic from 'next/dynamic'
import Image from 'next/image'
import Link from 'next/link'
import { dir } from 'i18next'
import { Box, Container, Grid } from '@mui/material'
import { NorthEast as NorthEastIcon, NorthWest as NorthWestIcon } from '@mui/icons-material'

// Types
import type { FooterProps } from '@/types/components/organisms/footer'

// Components
const BoxMolecule = dynamic(() => import('@/components/molecules/box'))
const DiamondMoelcule = dynamic(() => import('@/components/molecules/items/diamond'))
const DescriptionTypographyAtom = dynamic(() => import('@/components/atoms/typography/description'))
const PinkButtonAtom = dynamic(() => import('@/components/atoms/buttons/contained/pink'))
const ChartIconAtom = dynamic(() => import('@/components/atoms/icons/chart'))
const TimerIconAtom = dynamic(() => import('@/components/atoms/icons/timer'))
const DesignToolIconAtom = dynamic(() => import('@/components/atoms/icons/design-tool'))
const ReceiptIconAtom = dynamic(() => import('@/components/atoms/icons/receipt'))
const CrownIconAtom = dynamic(() => import('@/components/atoms/icons/crown'))
const StarIconAtom = dynamic(() => import('@/components/atoms/icons/star'))

const FooterOrganism = (props: FooterProps) => {
	// Props
	const { lng } = props

	// Variables
	const lngDir = dir(lng)

	return (
		<Box component="footer" mt={{ xs: 8, md: 16 }} position="relative">
			<BoxMolecule />

			<Box width={1} height="25dvw" position="absolute" bottom={0} left={0} overflow="hidden" zIndex={0}>
				<Box
					width="120dvw"
					height="120dvw"
					position="absolute"
					bottom="-160dvw"
					left="50dvw"
					sx={{
						transform: 'translate(-50%, -50%)',
						filter: 'drop-shadow(0px 4px 152.5px rgba(255, 145, 145, 0.19))'
					}}
				>
					<Image
						src="/images/items/circle.png"
						alt="footer"
						fill={true}
						style={{
							objectFit: 'cover',
							objectPosition: 'top center',
							transform: 'rotate(60.81deg)'
						}}
					/>
				</Box>
			</Box>

			<Container maxWidth="xl" sx={{ pb: { xs: 4, md: 8 } }}>
				<Grid container spacing={{ xs: 2, md: 4 }} sx={{ filter: 'drop-shadow(0px 4px 110px rgba(255, 160, 160, 0.35))' }}>
					<DiamondMoelcule lng={lng} title="common:title.precision" description="common:description.precision" icon={<ChartIconAtom />} rotate={-113} reverse />
					<DiamondMoelcule lng={lng} title="common:title.punctuality" description="common:description.punctuality" icon={<TimerIconAtom />} rotate={184} reverse />
					<DiamondMoelcule lng={lng} title="common:title.collaboration" description="common:description.collaboration" icon={<DesignToolIconAtom />} rotate={0} reverse />
					<DiamondMoelcule lng={lng} title="common:title.innovation" description="common:description.innovation" icon={<ReceiptIconAtom />} rotate={180} />
					<DiamondMoelcule lng={lng} title="common:title.dedication" description="common:description.dedication" icon={<CrownIconAtom />} rotate={133} />
					<DiamondMoelcule lng={lng} title="common:title.assurance" description="common:description.assurance" icon={<StarIconAtom />} rotate={6} />
				</Grid>

				<Grid container direction="column" alignItems="center" spacing={{ xs: 3.5, md: 7 }} my={{ xs: 3.5, md: 7 }}>
					<Grid size="auto">
						<DescriptionTypographyAtom lng={lng} text="common:description.ready" />
					</Grid>

					<Grid size="auto">
						<Link href="tel:+989374292056">
							<PinkButtonAtom title="form:button.contactUs" startIcon={lngDir === 'rtl' ? <NorthWestIcon /> : <NorthEastIcon />} />
						</Link>
					</Grid>
				</Grid>
			</Container>
		</Box>
	)
}

export default FooterOrganism
